import { AmplifyException } from '@futrli/shared-services';
import { FormattedMessage } from '@futrli/localisation';
import React from 'react';

import { getCustomDomain, getCustomBusinessPhoneNumber, getCustomBusinessType } from '../auth/service';
import { SignUpFormData, UserSignUpAttributes } from '../register/types';
import { AuthError } from '../core/types';
import { EXISTING_XERO_USER_MSG_KEY } from '../register/constants';

/**
 * Format the form data to the user attributes format to store in cognito.
 * @param {SignUpFormData} userData - Sign up form date
 * @returns {UserSignUpAttributes}
 */
export const getUserAttributesFormData = ({
  businessPhoneNumber = '',
  businessType = '',
  name = '',
  username = ''
}: SignUpFormData): UserSignUpAttributes => {
  const [given_name, ...family_name] = name.split(' ');
  const userAttributes = {
    ...getCustomDomain(),
    ...getCustomBusinessPhoneNumber(businessPhoneNumber),
    ...getCustomBusinessType(businessType),
    given_name,
    family_name: family_name.join(' ')
  };

  return username ? { ...userAttributes, email: username } : userAttributes;
};

export const getRegisterErrorMessage = (cognitoSignUpError?: AuthError) => {
  if (cognitoSignUpError?.code === AmplifyException.UsernameExists) {
    return (
      <FormattedMessage
        id="register.username_exists"
        defaultMessage="There is already an account associated with this email address."
      />
    );
  }

  if (
    cognitoSignUpError?.code === AmplifyException.UserLambdaValidation &&
    cognitoSignUpError?.message.includes(EXISTING_XERO_USER_MSG_KEY)
  ) {
    return (
      <FormattedMessage
        id="register.xero_username_exists"
        defaultMessage="There is already an account associated with this email address, you can log in with Xero to see your account."
      />
    );
  }

  return (
    <FormattedMessage
      id="register.there_was_a_problem_signing_you_up"
      defaultMessage="Oops, there was a problem signing you up - please try again."
    />
  );
};
